import React, { Component, Fragment } from 'react';

import { UPLOAD_DIRECTORY, DATE_TIME_FORMAT, FLIGHT_STATUS, ORDER } from '../../../../../../constants/Define';
import { checkUndefine, formatMoney } from '../../../../../../helpers/functions';
import { humanizeDuration } from '../../../../../../utils/commonUtils';
import Wrapper from '../../../../common/component/Wrapper';
import Span from '../../../../common/component/Span';
import Skeleton from '../../../../common/component/Skeleton';
import Empty from '../../../../common/component/Empty';
import {
    StatusComponent
} from "../../../../common/component/Index";
import FontIcon, { SolidIcons } from '../../../../common/component/FontIcon';
import Collapse, { Panel } from '../../../../common/component/Collapse';
import Input, { InputGroup } from "../../../../common/component/Input";
import * as Func from '../../../../../../helpers/functions';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import { DatePickerComponent } from "../../../../common/component/Index";
import EllipsisText from '../../../../common/component/EllipsisText';
import Modal from "../../../../common/component/Modal";
import Flight from '../../../../../../models/Flight';

import { Icon, Divider, Popover, Tooltip, message, Descriptions } from 'antd';
import Ripple from '../../../../common/component/Ripple';
import { get, sumBy, isEqual, isUndefined, cloneDeep } from 'lodash';
import moment from 'moment';
import OrderBundleSurcharge from '../OrderBundleSurcharge'

import './FlightDetail.less';
import DetailStatusItem from '../DetailStatusItem';

const FLIGHT_DIRECTION = {
    DEPARTURE: 'flightInfo.departureFlights',
    RETURN: 'flightInfo.returnFlights',
};
const statusDisabledChange = [3, 4, 5];
const emptyFlight = new Flight();

const flightSuccessStatus = [2, 3]; //orderItemStatus 2: Đã bán
const bundleItemIds = [3, 4] //3: flight id, 4: hotel id
const fightTicketStatus = ["ISSUED"] //Đã xuất vé
export default class FlightDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapseState: [],
            editing: false,
            flightEditing: {},
            dataItem: null,
            keyName: 'departureCode',
            keyStatus: 'departureOrderStatus',
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.flight && !isEqual(this.props.flight, prevProps.flight)) {
            this.setState({ editing: false, flightEditing: cloneDeep(this.props.flight) });
        }
    }

    render() {
        const { t, flight, loading, itemTypes } = this.props;
        const { dataItem, keyName, departureOrderStatus, keyStatus } = this.state;
        const noDataFlight = isEqual(emptyFlight, flight) && !loading;
        return (
            <Wrapper className="flight-detail-wrapper" style={{ width: '100%' }}>
                {/* FLight Directions */}
                {this.renderFlights()}

                {/* Passengers */}
                {this.renderPassengers()}
                {this.renderBundleOrderSurcharge()}
                <DetailStatusItem 
                    title={`${t('item.order.changeStatus')} ${t('item.flight.title').toLowerCase()}`}
                    visible={!!dataItem}
                    onSave={this.onSaveStatus}
                    itemTypes={ORDER.TYPE_ITEM['3']}
                    onClose={() => this.setState({ dataItem: null })}
                    item={dataItem || {}}
                    keyName={departureOrderStatus}
                    keyStatus={keyStatus}
                />
            </Wrapper >
        )
    }
    
    checkBundleOrderSuccess = () => {
      const { flight, order } = this.props;
      if (!order || !flight) return false
      const isBundleOrder = order.itemTypes && bundleItemIds.every(value => order?.itemTypes?.includes(value))
      const isSuccessOrder = order.status === ORDER.ORDER_STATUS_OBJ.SUCCESS;
      const isPaid = order.paymentStatus === ORDER.PAYMENT_STATUS_OBJ.PAID;
      const isFlightDepartureSold = flightSuccessStatus.includes(flight.departureOrderStatus);
      const isFlightReturnSold = flightSuccessStatus.includes(flight.returnOrderStatus);
      const isFlightDepartureTicketIssued = fightTicketStatus.includes(flight.departureStatus);
      const isFlightReturnTicketIssued = fightTicketStatus.includes(flight.returnStatus);
      
      const isVisible = [
          isBundleOrder,
          isSuccessOrder,
          isPaid,
          isFlightReturnSold,
          isFlightDepartureSold,
          isFlightDepartureTicketIssued,
          isFlightReturnTicketIssued
      ].every(f => f === true);
      return isVisible
    }

    checkTodayIsSameOrBeforeCheckoutDate = () => {
        const reservation = get(this.props, 'reservations[0]') || {};
        const lengthOfStay = reservation.lengthOfStay || 0;

        //check today <= checkout date
        const checkoutDate = reservation.arrivalDate && moment(reservation.arrivalDate).add(lengthOfStay, 'days');
        return moment().startOf("day").isSameOrBefore(checkoutDate);
    }

    renderPushFixedChargeButton = () => {
      const { t, isPushingFixedCharge } = this.props;
      const isVisible = this.checkBundleOrderSuccess()
      return isVisible && <Ripple className={`btn btn-default`} disabled={isPushingFixedCharge} onClick={this.onPushFixedCharge}>{t(`action.pushFixedCharge`)} </Ripple>;
    }

    renderBundleOrderSurcharge = () => {
      const isVisible = this.checkBundleOrderSuccess() && this.checkTodayIsSameOrBeforeCheckoutDate();
      //   return isVisible && <OrderBundleSurcharge />
      const disableCreated = !isVisible;
      return <OrderBundleSurcharge disableCreated={disableCreated} />
    }

    renderFlights() {
        const { editing, flightEditing } = this.state
        const { t, flight, loading } = this.props;
        const noDataFlight = isEqual(emptyFlight, flight) && !loading;
        return (
            <Fragment>
                <Wrapper className="col-md-12 row m-0 p-0">
                    <Wrapper className={`col-md-7`}>
                        <h3 className={`title-button  editing-buttons ${editing ? 'editing' : ''}`}>
                            {t('item.order.flightInfos')}
                            <Ripple waitForEffect={true} className={`btn-edit p-1 mr-1 ml-2`} onClick={!editing ? this.onClickEdit : this.onClickCancel}><Icon type={editing ? 'close' : 'edit'} /> {editing ? t(`action.cancel`) : t(`action.edit`)}</Ripple>
                            {editing && <Ripple waitForEffect={true} className={`btn-save p-1`} disabled={loading || isEqual(flightEditing, flight)} onClick={this.onClickSave}><Icon type='save' /> {t(`action.save`)} </Ripple>}
                            {this.renderPushFixedChargeButton()}
                        </h3>
                    </Wrapper>
                    {!loading
                        ? <Wrapper className={`col-md-5 text-right total-price`}>{formatMoney(flight.totalPrice)}<Span className="currency ml-1">{t(`currencySymbol`)}</Span></Wrapper>
                        : <Skeleton className={`col-md-5 text-right total-price`} count={1} height={15} width={150} />
                    }
                </Wrapper>
                
                    <Descriptions bordered className="white-bg w100-percent" column={2}>
                        <Descriptions.Item label={t('item.order.departureSellAccount')} className='w-30' >
                            {this.renderSaleAccount(flight?.flightInfo)}
                        </Descriptions.Item>
                        {flight.returnOrderStatus && <Descriptions.Item label={t('item.order.returnSellAccount')} className='w-30' >
                            {this.renderSaleAccount(flight?.flightInfo, true)}
                        </Descriptions.Item>
                        }
                    </Descriptions>
                    <Descriptions bordered className="white-bg w100-percent" column={2}>
                        <Descriptions.Item label={t('item.order.departureOrderStatus')} className='w-30'>
                            {this.renderStatusOrder(flight.departureOrderStatus)}
                        </Descriptions.Item>
                        {flight.returnOrderStatus && <Descriptions.Item label={t('item.order.returnOrderStatus')} className='w-30'>
                            {this.renderStatusOrder(flight.returnOrderStatus, true)}
                        </Descriptions.Item>
                        }
                    </Descriptions>
                
                <Wrapper className="flight-detail col-md-12 row mb-4">
                    {!noDataFlight ?
                        <Collapse bordered={false}
                            style={{ width: '100%' }}
                            defaultActiveKey={[FLIGHT_DIRECTION.DEPARTURE, FLIGHT_DIRECTION.RETURN]}
                            expandIconPosition={'right'}
                        >
                            {this.renderFlightDirection(FLIGHT_DIRECTION.DEPARTURE)}
                            {!loading && this.renderFlightDirection(FLIGHT_DIRECTION.RETURN)}
                        </Collapse>
                        : this.renderEmpty()
                    }
                </Wrapper>
            </Fragment>
        )
    }

    renderPassengers() {
        const { t, flight, loading } = this.props;
        const passengerInfo = flight.passengerInfo;
        const activeKeys = passengerInfo.length ? [...Array(10).keys()].map(k => String(k)) : []
        return (!!passengerInfo.length &&
            <Fragment>
                <Wrapper className="col-md-12 row m-0 p-0 mt-3">
                    <Wrapper className={`col-md-6`}><h3>{t('item.flight.passengerInfos')}</h3></Wrapper>
                </Wrapper>
                <Wrapper className="passenger-detail col-md-12 row mb-4">
                    {passengerInfo.map((passenger, index) => (
                        <Collapse key={index} bordered={false}
                            style={{ width: '100%' }}
                            defaultActiveKey={activeKeys}
                            expandIconPosition={'right'}
                        >
                            {this.renderPassenger(passenger, index)}
                        </Collapse>
                    ))}
                </Wrapper>
            </Fragment>
        )
    }

    renderFlightDirection(directionKey) {
        const { t, flight, loading } = this.props;
        const flightDirection = get(flight, directionKey) || {};
        const hadData = (!!Object.keys(flightDirection).length && !isEqual(flightDirection, get(emptyFlight, directionKey)));
        const showPanel = hadData || loading;
        return (showPanel &&
            <Panel className="flight-direction-item"
                key={directionKey}
                header={this.renderFlightHeader(flightDirection, directionKey)}
            >
                {this.renderFlightContent(flightDirection, directionKey)}
            </Panel>
        )
    }

    renderFlightHeader(flightDirection, directionKey) {
        const { t, flight, loading } = this.props;
        const data = get(flight, directionKey) || {};
        const fareOption = get(data, 'fareOptions[0]') || {};
        const startPointCityName = get(data, 'listSegment[0].startPointCityName');
        const endPointCityName = flightDirection.stops > 0 ? get(data, `listSegment[${data.listSegment.length - 1}].endPointCityName`) : get(data, 'listSegment[0].endPointCityName');

        return (!loading
            ? <Wrapper className="col-md-12 row flight-direction-header">
                <Wrapper className="flight-direction-header-item">
                    <Wrapper className="title">{checkUndefine(data.airlineName || get(data, 'listSegment[0].airlineName'))}</Wrapper>
                    <Wrapper className="subtitle">{checkUndefine(data.flightNumber)}</Wrapper>
                </Wrapper>
                <Wrapper className="flight-direction-header-item">
                    <Wrapper className="title">{!!startPointCityName && `${checkUndefine(startPointCityName)} (${checkUndefine(data.startPoint)})`}</Wrapper>
                    <Wrapper className="subtitle">{checkUndefine(get(data, 'listSegment[0].startPointName'))}</Wrapper>
                </Wrapper>
                <FontIcon icon={SolidIcons.faPlane} className="orange" size="lg" />
                <Wrapper className="flight-direction-header-item">
                    <Wrapper className="title">{!!endPointCityName && `${checkUndefine(endPointCityName)} (${checkUndefine(data.endPoint)})`}</Wrapper>
                    <Wrapper className="subtitle">{checkUndefine(flightDirection.stops > 0 ? get(data, `listSegment[${data.listSegment.length - 1}].endPointName`) : get(data, 'listSegment[0].endPointName'))}</Wrapper>
                </Wrapper>
                <Wrapper className="divider-vertical"></Wrapper>
                <Wrapper className="flight-direction-header-item">
                    <Wrapper className="title">{data.startDate && data.startDate.format(DATE_TIME_FORMAT.DAY_WEEK_DATETIME)}</Wrapper>
                    <Wrapper className="subtitle">{t(`item.flight.departureDate`)}</Wrapper>
                </Wrapper>
                <Wrapper className="flight-direction-header-item">
                    <Wrapper className="text-right title price">{formatMoney(fareOption.totalPrice)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                </Wrapper>
            </Wrapper>
            : <Skeleton className="col-md-12 row flight-direction-header" count={2} height={15} width={'100%'} />
        )
    }

    renderFlightContent(flightDirection, directionKey) {
        const { t, flight, loading, itemTypes } = this.props;
        const data = get(flight, directionKey) || {};
        const fareOption = get(data, 'fareOptions[0]') || {};
        const startPointName = get(data, 'listSegment[0].startPointName');
        const endPointName = flightDirection.stops > 0 ? get(data, `listSegment[${data.listSegment.length - 1}].endPointName`) : get(data, 'listSegment[0].endPointName');
        const baggagePrice = flight.baggageInfo[directionKey === FLIGHT_DIRECTION.DEPARTURE ? 'departure' : 'return'] || 0;
        const keyCode = directionKey === FLIGHT_DIRECTION.DEPARTURE ? 'departureCode' : 'returnCode'
        const keyLastTkDate = directionKey === FLIGHT_DIRECTION.DEPARTURE ? 'departureLastTkDate' : 'returnLastTkDate'
        const keyMessage = directionKey === FLIGHT_DIRECTION.DEPARTURE ? 'departureMessage' : 'returnMessage'
        const keyStatus = directionKey === FLIGHT_DIRECTION.DEPARTURE ? 'departureStatus' : 'returnStatus'
        return (
            <Wrapper className="col-md-12 row flight-direction-content">
                <Wrapper className="col-md-12 row m-0 p-0">
                    {!loading
                        ? <Fragment>
                            <Wrapper className="col-md-3">
                                <Wrapper className="subtitle"><FontIcon icon={SolidIcons.faPlane} className="orange mr-1" />{t(`item.flight.flightNumber`)}</Wrapper>
                                <Wrapper className="title">{data.flightNumber}</Wrapper>
                            </Wrapper>
                            <Wrapper className="col-md-3">
                                <Wrapper className="subtitle"><Icon className="orange mr-1" type="environment" />{t(`item.flight.startPoint`)}</Wrapper>
                                <Wrapper className="title">{data.startDate && data.startDate.format(DATE_TIME_FORMAT.TIME_AND_DATE)}</Wrapper>
                                <Wrapper className="subtitle">{!!startPointName && `${checkUndefine(startPointName)} (${checkUndefine(data.startPoint)})`}</Wrapper>
                            </Wrapper>
                            <Wrapper className="col-md-3">
                                <Wrapper className="subtitle"><Icon className="orange mr-1" type="environment" />{t(`item.flight.endPoint`)}</Wrapper>
                                <Wrapper className="title">{data.endDate && data.endDate.format(DATE_TIME_FORMAT.TIME_AND_DATE)}</Wrapper>
                                <Wrapper className="subtitle">{!!endPointName && `${checkUndefine(endPointName)} (${checkUndefine(data.endPoint)})`}</Wrapper>
                            </Wrapper>
                            <Wrapper className="col-md-3">
                                <Wrapper className="subtitle"><Icon className="orange mr-1" type="clock-circle" />{t(`item.flight.flightDuration`)}</Wrapper>
                                <Wrapper className="title">{humanizeDuration(data.duration * 60000)}</Wrapper>
                                <Wrapper className="subtitle">
                                    {!!data.duration && data.stops > 0 
                                        ?  <Popover placement="top" title={t(`item.flight.titleListSegment`)} content={this.renderListSegment([...data.listSegment])} trigger="hover">
                                            <span className="flight-over-stops">{t(`item.flight.flightOverStops`).replace('%n', data.stops)}</span>
                                            </Popover>
                                        : t(`item.flight.directFlight`)}
                                   
                                </Wrapper>
                            </Wrapper>
                        </Fragment>
                        : <Skeleton className="col-md-12 row m-0 p-0" count={3} height={15} width={'100%'} />
                    }
                </Wrapper>
                <Wrapper className="col-md-12 row m-0 p-0">
                    <Fragment>
                        <Wrapper className="col-md-3 m-t">
                            <Wrapper className="subtitle"><Icon className="orange mr-1" type="barcode" />{t(`item.flight.flightOrderCode`)}</Wrapper>
                            <Wrapper className="title">
                                {this.renderInput(keyCode, 'code')}
                            </Wrapper>
                        </Wrapper>
                        <Wrapper className="col-md-3 m-t">
                            <Wrapper className="subtitle"><Icon className="orange mr-1" type="calendar" />{t(`item.flight.lastTKDate`)}</Wrapper>
                            <Wrapper className="title">
                                {this.renderDate(keyLastTkDate, 'lastTKDate')}
                            </Wrapper>
                        </Wrapper>
                        <Wrapper className="col-md-3 m-t">
                            <Wrapper className="subtitle"><Icon className="orange mr-1" type="message" />{t(`item.flight.message`)}</Wrapper>
                            <Wrapper className="title">
                                {this.renderInput(keyMessage, 'message')}
                            </Wrapper>
                        </Wrapper>
                        <Wrapper className="col-md-3 m-t">
                            <Wrapper className="subtitle"><Icon className="orange mr-1" type="question-circle" />{t(`item.flight.status`)}</Wrapper>
                            <Wrapper className="title">
                                {this.renderSelectEnum(keyStatus)}
                            </Wrapper>
                        </Wrapper>
                    </Fragment>
                </Wrapper>
                <Divider />
                {this.renderPrices(fareOption)}
                <Divider />
                {
                    itemTypes.includes(ORDER.TYPES.HOTEL.id) && 
                    <Wrapper className="col-md-12 row m-0 p-0">
                        <Wrapper className="col-md-12 row m-0 p-0">
                            <Wrapper className="col-md-2 title">{t(`item.flight.markupPrice`)}</Wrapper>
                            <Wrapper className="col-md-7"></Wrapper>
                            <Wrapper className="col-md-3 title text-right">{formatMoney(fareOption.markupPrice)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                        </Wrapper>
                        <Divider />
                    </Wrapper>
                    
                }
                <Wrapper className="col-md-12 row m-0 p-0">
                    {!loading
                        ? <Wrapper className="col-md-12 row m-0 p-0">
                            <Wrapper className="col-md-2 title">{t(`item.flight.baggage`)}</Wrapper>
                            <Wrapper className="col-md-7"></Wrapper>
                            <Wrapper className="col-md-3 title text-right">{formatMoney(baggagePrice)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                        </Wrapper>
                        : <Skeleton className="col-md-12 row m-0 p-0" count={1} height={15} width={'100%'} />
                    }
                </Wrapper>
                <Divider />
                <Wrapper className="col-md-12 row m-0 p-0">
                    <Wrapper className="col-md-6 title">{t(`item.flight.totalPrice`)}</Wrapper>
                    {!loading
                        ? <Wrapper className="col-md-6 title row m-0 p-0">
                            <Wrapper className="col-md-12 text-right total-price">{formatMoney(fareOption.totalPrice + baggagePrice)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            <Wrapper className="col-md-12 text-right subtitle red">*{t(`item.flight.priceIncludedTaxesAndFees`)}</Wrapper>
                        </Wrapper>
                        : <Skeleton className="col-md-12 row m-0 p-0" count={2} height={15} width={'100%'} />
                    }
                </Wrapper>
            </Wrapper>
        )
    }

    renderPrices(options) {
        const { t, flight, loading } = this.props;
        
        return (
            <Wrapper className="col-md-12 row m-0 p-0">
                <Wrapper className="col-md-12 row m-0 p-0">
                    <Wrapper className="col-md-2 subtitle"></Wrapper>
                    <Wrapper className="col-md-1 subtitle text-right">{t(`item.flight.quantity`)}</Wrapper>
                    <Wrapper className="col-md-2 subtitle text-right">{t(`item.flight.ticketPrice`)}</Wrapper>
                    <Wrapper className="col-md-2 subtitle text-right">{t(`item.flight.taxesAndFees`)}</Wrapper>
                    {/* {!itemTypes.includes(ORDER.TYPES.HOTEL.id) ? <Wrapper className="col-md-3 subtitle text-right">{t(`item.flight.vptServiceFee`)}</Wrapper>
                        :
                        <Wrapper className="col-md-3 row m-0 p-0" >
                            <Wrapper className="col-md-6 subtitle text-right">{t(`item.flight.vptServiceFee`)}</Wrapper> 
                            <Wrapper className="col-md-6 subtitle text-right">{t(`item.flight.markupPrice`)}</Wrapper>
                        </Wrapper>
                    } */}
                    <Wrapper className="col-md-3 subtitle text-right">{t(`item.flight.vptServiceFee`)}</Wrapper>
                    <Wrapper className="col-md-2 subtitle text-right">{t(`item.flight.total`)}</Wrapper>
                </Wrapper>
                {!loading ?
                    <Fragment>
                        <Wrapper className="col-md-12 row m-0 p-0">
                            <Wrapper className="col-md-2 title">{t(`item.flight.adult`)}</Wrapper>
                            <Wrapper className="col-md-1 title text-right">{flight.flightInfo.adult}</Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.adult > 0 ? formatMoney(options.priceAdult) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.adult > 0 ? formatMoney(this.getFareTaxAndFee(options, 'Adult')) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            <Wrapper className="col-md-3 title text-right">{flight.flightInfo.adult > 0 ? flight.flightInfo.adult && formatMoney(options.vptServiceFee) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            {/* {
                                !itemTypes.includes(ORDER.TYPES.HOTEL.id) ? 
                                <Wrapper className="col-md-3 title text-right">{flight.flightInfo.adult && formatMoney(options.vptServiceFee)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                                : 
                                <Wrapper className="col-md-3 row m-0 p-0" >
                                    <Wrapper className="col-md-6 title text-right">{flight.flightInfo.adult && formatMoney(options.vptServiceFee)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper> 
                                    <Wrapper className="col-md-6 title text-right">{formatMoney(options.markupPrice)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                                </Wrapper>
                            } */}
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.adult > 0 ? formatMoney(this.getFareTotalPrice(options, flight.flightInfo.adult, 'Adult')) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                        </Wrapper>
                        <Wrapper className="col-md-12 row m-0 p-0">
                            <Wrapper className="col-md-2 title">{t(`item.flight.children`)}</Wrapper>
                            <Wrapper className="col-md-1 title text-right">{flight.flightInfo.children}</Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.children > 0 ? formatMoney(options.priceChild) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.children > 0 ? formatMoney(this.getFareTaxAndFee(options, 'Child')) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            {/* {
                                !itemTypes.includes(ORDER.TYPES.HOTEL.id) ? 
                                <Wrapper className="col-md-3 title text-right">
                                    {flight.flightInfo.children && formatMoney(options.vptServiceFee)}
                                    <Span className="currency">{t(`currencySymbol`)}</Span>
                                </Wrapper>
                                : 
                                <Wrapper className="col-md-3 row m-0 p-0" >
                                    <Wrapper className="col-md-6 title text-right">{flight.flightInfo.children && formatMoney(options.vptServiceFee)}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper> 
                                    <Wrapper className="col-md-6 title text-right">{0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                                </Wrapper>
                            } */}
                            <Wrapper className="col-md-3 title text-right">
                                {flight.flightInfo.children > 0 ? flight.flightInfo.children && formatMoney(options.vptServiceFee) : 0}
                                <Span className="currency">{t(`currencySymbol`)}</Span>
                            </Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.children > 0 ? formatMoney(this.getFareTotalPrice(options, flight.flightInfo.children, 'Child')) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                        </Wrapper>
                        <Wrapper className="col-md-12 row m-0 p-0">
                            <Wrapper className="col-md-2 title">{t(`item.flight.infant`)}</Wrapper>
                            <Wrapper className="col-md-1 title text-right">{flight.flightInfo.infant}</Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.infant > 0 ? formatMoney(options.priceInfant) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.infant > 0 ? formatMoney(this.getFareTaxAndFee(options, 'Infant')) : 0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                            {/* {
                                 !itemTypes.includes(ORDER.TYPES.HOTEL.id) ? 
                                 <Wrapper className="col-md-3 title text-right">
                                        0 <Span className="currency">{t(`currencySymbol`)}</Span>
                                </Wrapper>
                                : 
                                <Wrapper className="col-md-3 row m-0 p-0" >
                                    <Wrapper className="col-md-6 title text-right">{0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper> 
                                    <Wrapper className="col-md-6 title text-right">{0}<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                                </Wrapper>
                            } */}
                            <Wrapper className="col-md-3 title text-right">
                                {/* {flight.flightInfo.infant && formatMoney(options.vptServiceFee)} */}
                                    0<Span className="currency">{t(`currencySymbol`)}</Span>
                            </Wrapper>
                            <Wrapper className="col-md-2 title text-right">{flight.flightInfo.infant > 0 ? formatMoney(this.getFareTotalPrice(options, flight.flightInfo.infant, 'Infant')) : 0 }<Span className="currency">{t(`currencySymbol`)}</Span></Wrapper>
                        </Wrapper>
                    </Fragment>
                    : <Skeleton className="col-md-12 row m-0 p-0" count={3} height={15} width={'100%'} />
                }
            </Wrapper>
        )
    }

    renderPassenger(passenger, index) {
        const { t } = this.props;
        return (
            <Panel className="passenger-detail-item"
                key={String(index)}
                header={
                    <Wrapper className="passenger-detail-header col-md-12 row m-0 p-0">
                        <Wrapper className="col-md-6">
                            <Span className="name">{`${passenger.firstName} ${passenger.lastName}`}</Span>
                        </Wrapper>
                        <Wrapper className="col-md-6 text-right">
                            <Span className="name">{`(${t(`item.flight.passngerTypes.${passenger.type}`)})`}</Span>
                        </Wrapper>
                    </Wrapper>
                }
            >
                <Wrapper className="passenger-detail-content col-md-12 row m-0 p-0">
                    <Wrapper className="col-md-3 row m-0 p-0">
                        <Wrapper className="col-md-4 subtitle">{t(`item.flight.birthday`)}</Wrapper>
                        <Wrapper className="col-md-8 title">{passenger.birthday && passenger.birthday.format(DATE_TIME_FORMAT.SHORT_DATE)}</Wrapper>
                    </Wrapper>
                    <Wrapper className="col-md-3 row m-0 p-0">
                        <Wrapper className="col-md-4 subtitle">{t(`item.flight.gender`)}</Wrapper>
                        <Wrapper className="col-md-8 title">
                            {passenger.gender !== undefined && t(`item.flight.${passenger.type === 'ADT' ? 'genderTypesAdult' : 'genderTypes'}.${passenger.gender}`)}
                        </Wrapper>
                    </Wrapper>
                    <Wrapper className="col-md-3 row m-0 p-0">
                        <Wrapper className="col-md-4 subtitle">{t(`item.flight.email`)}</Wrapper>
                        <Wrapper className="col-md-8 title">{passenger.email}</Wrapper>
                    </Wrapper>
                    <Wrapper className="col-md-3 row m-0 p-0">
                        <Wrapper className="col-md-4 subtitle">{t(`item.flight.phone`)}</Wrapper>
                        <Wrapper className="col-md-8 title">{passenger.phone}</Wrapper>
                    </Wrapper>
                    {(!!passenger.baggageDeparturePrice || !!passenger.baggageReturnPrice) && <Divider />}
                    {!!passenger.baggageDeparturePrice &&
                        <Wrapper className="col-md-6 row m-0 p-0">
                            <Wrapper className="col-md-4 subtitle">{t(`item.flight.baggageDeparture`)}</Wrapper>
                            <Wrapper className="col-md-8 title">{formatMoney(passenger.baggageDeparturePrice)}<Span className="currency">{t(`currencySymbol`)}</Span>{passenger.baggageDeparture ? ` (${passenger.baggageDeparture}${t(`item.flight.baggageWeightUnit`)})` : ''}</Wrapper>
                        </Wrapper>
                    }
                    {!!passenger.baggageReturnPrice &&
                        <Wrapper className="col-md-6 row m-0 p-0">
                            <Wrapper className="col-md-4 subtitle">{t(`item.flight.baggageReturn`)}</Wrapper>
                            <Wrapper className="col-md-8 title">{formatMoney(passenger.baggageReturnPrice)}<Span className="currency">{t(`currencySymbol`)}</Span>{passenger.baggageReturn ? ` (${passenger.baggageReturn}${t(`item.flight.baggageWeightUnit`)})` : ''}</Wrapper>
                        </Wrapper>
                    }
                    {passenger.departureTicketNumber &&
                        <Wrapper className="col-md-3 row m-0 p-0">
                            <Wrapper className="col-md-4 subtitle">{t(`item.flight.departureTicketNumber`)}</Wrapper>
                            <Wrapper className="col-md-8 title">{passenger.departureTicketNumber}</Wrapper>
                        </Wrapper>
                    }
                    {passenger.returnTicketNumber &&
                        <Wrapper className="col-md-3 row m-0 p-0">
                            <Wrapper className="col-md-4 subtitle">{t(`item.flight.returnTicketNumber`)}</Wrapper>
                            <Wrapper className="col-md-8 title">{passenger.returnTicketNumber}</Wrapper>
                        </Wrapper>
                    }
                </Wrapper>
            </Panel>
        )
    }

    renderEmpty = () => {
        const { t } = this.props;
        return (
            <Wrapper style={{ width: '100%' }}>
                <Empty />
            </Wrapper>
        )
    }

    renderStatusOrder = (status, isReturn = false) => {
        const { flightEditing } = this.state;
        return status && (
            <Wrapper>
                <StatusComponent color={this.props.t(`item.order.orderItemStatusColor.${status}`)}
                    label={this.props.t(`item.order.orderItemStatus.${status}`)} />
                { !statusDisabledChange.includes(status) && this.props.permisions.allowChangeStatus && 
                        <Tooltip title={this.props.t(`action.changeStatus`)} placement="top">
                            <Icon type="edit" className="fs20 colorPrimary" onClick={() => this.onClickChangeStatus(flightEditing, isReturn)} />
                        </Tooltip>
                        }
            </Wrapper>
         )
    }

    renderSaleAccount = (flightInfo = {}, isReturn = false) => {
        const {departSourceName, departAccountName, returnSourceName, returnAccountName} = flightInfo;
        return (
            <Wrapper>
                {isReturn
                    ? <span>{`${returnSourceName}/${returnAccountName}`}</span>
                    : <span>{`${departSourceName}/${departAccountName}`}</span>
                }
            </Wrapper>
         )
    }

    renderInput = (keyEdit, keyLang) => {
        const { t, flight } = this.props
        const { editing, flightEditing } = this.state
        return (
            editing ? 
            <Input value={flightEditing[keyEdit]}
                    onPressEnter={this.onClickSave}
                        placeholder={t(`item.flight.${keyLang}`)}
                        onChange={e => this.onChangeEditing(keyEdit, e.target.value)} /> 
            : flight[keyEdit] && <EllipsisText title={flight[keyEdit]} content={flight[keyEdit]} contentMaxWidth={280}
            overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
        )
    }

    renderSelectEnum = (keyEdit) => {
        const { t, flight } = this.props;
        const { editing, flightEditing } = this.state;
        return (editing
            ? (
                <AntSelect className="select-enum"
                    showArrow showSearch
                    placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t(`item.flight.flightStatus`)).toLowerCase())}
                    value={flightEditing[keyEdit] ? t(`item.flight.flightStatus.${flightEditing[keyEdit]}`) : null}
                    onChange={(e) => this.onChangeEditing(keyEdit, e)}
                    style={{ width: '100%' }}
                    filterOption={this.selectFilterSearch}
                >
                    {FLIGHT_STATUS.map(item => (
                        <AntOption key={item} value={item}>{t(`item.flight.flightStatus.${item}`)}</AntOption>
                    ))}
                </AntSelect>
            )
            :  flight[keyEdit] && <StatusComponent color={flight[keyEdit] === 'HELD' || flight[keyEdit] === 'ISSUED' ? 'green' : 'red'}
            label={t(`item.flight.flightStatus.${flight[keyEdit]}`)} /> 
        )
    }

    renderDate = (keyEdit) => {
        const { t, flight } = this.props;
        const { editing, flightEditing } = this.state;
        return (editing 
            ? <DatePickerComponent
                    disabledDate={(current) => current && current < moment().add(-1, 'day')}
                    onChange={data => this.onChangeEditing(data.name, data.fullValue)}
                    showTime
                    name={keyEdit}
                    format={DATE_TIME_FORMAT.DATE_TIME}
                    value={flightEditing[keyEdit] || null}
                    placeholder=""
                    style={{ width: '100%' }}
                />
            : flight[keyEdit] && flight[keyEdit].format(DATE_TIME_FORMAT.DATE_TIME)
        ) 
    }

    onChangeEditing = (fieldName, value) => {
        const flightEditing = this.state.flightEditing;
        flightEditing[fieldName] = value;
        this.setState({ flightEditing })
    }

    onClickEdit = () => {
        this.setState({
            editing: true,
            flightEditing: cloneDeep(this.props.flight)
        })
    }
    

    onClickCancel = () => {
        this.setState({
            editing: false
        })
    }

    onClickSave = () => {
        this.props.onUpdateFlight(this.state.flightEditing)
    }
    onPushFixedCharge = () => {
        const { t } = this.props;
        const { confirm } = Modal;
            confirm({
                title: t(`item.order.confirmPushFixedCharge`),
                okText: t(`action.pushFixedCharge`),
                cancelText: t(`action.cancel`),
                onOk: () => {
                  
                    this.props.onPushFixedCharge && this.props.onPushFixedCharge(this.props.order)
                },
            });
    }

    getFareTaxAndFee = (fareOption, suffix) => {
        return fareOption[`tax${suffix}`] + fareOption[`fee${suffix}`] + fareOption.serviceFee + fareOption.issueFee;
    }

    getFareTotalPrice = (fareOption, quantity, suffix) => {
        const vptServiceFee = suffix !== 'Infant' ? fareOption.vptServiceFee : 0;
        return (fareOption[`price${suffix}`] + this.getFareTaxAndFee(fareOption, suffix) + vptServiceFee) * quantity;
    };

    renderListSegment = (segments) => {
        const { t } = this.props;
        const dataSegments = [...segments];
        const listSegments = (
            dataSegments.map((item, index) => {
                const startDate = get(dataSegments, `[${index + 1}].startDate`)
                if(!startDate) {
                    return;
                }
                const endDate = item.endDate
                const transitDuration = moment.duration(endDate.diff(startDate, 'miliseconds'))
            return <p key={index}>{t(`item.flight.segmentEnd`).replace('%n', index + 1)}  : {item.endPointCityName} - {item.endPointName} ({item.endPoint}) {t(`item.flight.overStopTime`).replace('%n', humanizeDuration(transitDuration))}</p>
            })
        )
        return listSegments
    }

    onClickChangeStatus = (item, isReturn) => {
        this.setState({ keyStatus: !isReturn ? 'departureOrderStatus' : 'returnOrderStatus' })
        this.setState({ dataItem: {...item, isReturn} })
    }

    onSaveStatus = (orderItem, keyStatus) => {
        if(this.props.onUpdateItem){
            orderItem.orderItemType = 3;
            orderItem.status = orderItem[keyStatus]
            this.props.onUpdateItem(orderItem)
        }
        this.setState({ dataItem: null })
    }

}

FlightDetail.defaultProps = {
    flight: new Flight(),
    onUpdateFlight: flight => { },
}

